import loadable from 'utils/loadable'
import type { LoginPageProps } from './index'

export default loadable<LoginPageProps>(() => import('./index'))
